import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
import _ from 'lodash';
import { Header, Message, Button, Form, Dimmer, Loader, Divider } from 'semantic-ui-react';
import { Redirect, Route } from 'react-router-dom';
// import { withFormik } from 'formik';
import gql from 'graphql-tag';
// import { graphql } from 'react-apollo';
// import compose from 'lodash/flowRight';
import PinInput from 'react-pin-input';
import { AuthClient, EnjoyIcon, EventSystem } from '@emyw/core-lib';
import queryString from 'query-string';
import { normalizeErrors, isOpera, isChrome, isBlink } from '../utils';
import ButtonLink from '../ButtonLink';
import '../primitives.css';
const validateSetPinLinkMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($resetToken: String!) {\n        validateSetPinLink(resetToken: $resetToken) {\n            ok\n            email\n            pin\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const updateAccountPinMutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation ($resetToken: String!, $pin: String) {\n        updateAccountPin(resetToken: $resetToken, pin: $pin) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
export default class SetPinForm extends React.Component {
  constructor(props) {
    super(props);
    this.validateLink = () => {
      const resetToken = queryString.parse(window.location.search).t;
      if (!resetToken) {
        this.setState({
          status: 'noLink'
        });
      } else {
        /** If we are in a status of validatingLink then call the validate mutation
         * This will check if the link matches a specific user and if it has not expired */
        this.setState({
          status: 'validatingLink'
        });
        log.trace('checking pin link', resetToken);
        AuthClient.mutate({
          mutation: validateSetPinLinkMutation,
          variables: {
            resetToken
          }
        }).then(response => {
          const {
            ok,
            email,
            pin: hadaPin,
            errors
          } = response.data.validateSetPinLink;
          log.trace('validateSetPinLink', ok, errors);
          if (ok) {
            this.setState({
              status: 'validLink',
              email,
              hadaPin
            });
          } else {
            this.setState({
              status: 'invalidLink',
              errors: normalizeErrors(errors)
            });
          }
        }).catch(error => {
          log.error(error);
          this.setState({
            status: 'invalidLink',
            errors: normalizeErrors([{
              path: 'pin',
              message: 'PIN must be 4 digits long'
            }])
          });
        });
      }
    };
    this.handleSetPinClick = _ref => {
      let {
        removePin
      } = _ref;
      const {
        pin
      } = this.state;
      const resetToken = queryString.parse(window.location.search).t;
      log.trace('removePin', removePin);
      if (!removePin && pin.length !== 4) {
        this.setState({
          errors: normalizeErrors([{
            path: 'pin',
            message: 'PIN must be 4 characters long'
          }])
        });
      } else {
        this.setState({
          errors: [],
          isSubmitting: true
        });
        AuthClient.mutate({
          mutation: updateAccountPinMutation,
          variables: {
            resetToken,
            pin: removePin ? null : pin
          }
        }).then(response => {
          const {
            ok,
            errors
          } = response.data.updateAccountPin;
          if (ok) {
            this.setState({
              status: removePin ? 'removePinSuccess' : 'setPinSuccess',
              isSubmitting: false
            });
            EventSystem.publish('enjoyAuthTokensUpdated');
          } else {
            this.setState({
              status: 'setPinFail',
              errors: normalizeErrors(errors),
              isSubmitting: false
            });
          }
        });
      }
    };
    this.handlePinInputChange = (value /* , index e, data */) => {
      // log.trace(data);
      this.setState({
        pin: value /* data.value */
      });
    };
    this.focusOnSetPin = () => {
      if (!this.setPinButton) return;
      this.setPinButton.focus();
    };
    /* Prevent autofill */
    this.handlePinRef = ref => {
      if (!ref) return;
      (ref.elements || []).forEach(element => {
        if (!(element || {}).input) return;
        element.input.setAttribute('autocomplete', 'new-password');
        element.input.setAttribute('data-lpignore', 'true');
        // log.trace('input:', element.input);
      });
    };
    this.state = {
      status: 'validateLink',
      pin: undefined,
      errors: []
    };
    if (window.location.href.match(/http:\/\/localhost:3007\/(\?path=\/story\/|iframe\.html\?id=)2-auth-set-pin-form--set-pin-initial/)) {
      log.warn('testing - setting state to validLink');
      this.state.status = 'validLink';
    }
  }
  componentDidMount() {
    const {
      status
    } = this.state;
    // use this to stop chrome from prompting to save these as passwords
    // If not chrome, then we'll just set the type to password (i.e. secret = true). If it is chrome, we'll use the
    // textSecurity: 'disc' trick for a input type='text', which doesn't work in other browsers.
    this.useSecret = !(isChrome || isOpera || isBlink);
    if (status === 'validateLink') this.validateLink();
  }
  componentDidUpdate() {
    // log.trace('updated');
    const {
      status
    } = this.state;
    if (status === 'validateLink') this.validateLink();
  }
  render() {
    const {
      status,
      errors,
      email,
      hadaPin,
      isSubmitting
    } = this.state;
    const {
      onManageAccount
    } = this.props;
    // log.trace('status:', status);
    if (!['validateLink', 'validatingLink', 'invalidLink'].includes(status) && !email) {
      return /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: '/login'
        }
      }));
    }
    return /*#__PURE__*/React.createElement("div", null, ['validatingLink', 'validateLink'].includes(status) && /*#__PURE__*/React.createElement(Dimmer, {
      active: true
    }, /*#__PURE__*/React.createElement(Loader, {
      indeterminate: true
    }, "Processing Link...")), status === 'validLink' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
      attached: "top",
      color: "blue"
    }, /*#__PURE__*/React.createElement(EnjoyIcon, {
      className: "formTitleIcon"
    }), " \xA0 Set PIN for: ", email), /*#__PURE__*/React.createElement(Divider, {
      hidden: true
    }), /*#__PURE__*/React.createElement(Form, {
      className: "enjoyPinInputForm"
    }, /*#__PURE__*/React.createElement(Form.Field, {
      error: !!errors.pin
    }, /*#__PURE__*/React.createElement(PinInput, {
      ref: this.handlePinRef,
      length: 4,
      secret: this.useSecret,
      onChange: this.handlePinInputChange,
      type: "numeric",
      style: {
        padding: ''
      } // Required to allow css file to set
      /* Empty border and margin required to allow css file to set, security related styles to prevent autofill: */,
      inputStyle: {
        textSecurity: 'disc',
        WebkitTextSecurity: 'disc',
        border: '',
        margin: ''
      },
      inputFocusStyle: {
        border: ''
      } // Required to allow css file to set
      ,
      onComplete: this.focusOnSetPin
    })), /*#__PURE__*/React.createElement(Divider, {
      hidden: true
    }), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Button, {
      ref: ref => {
        this.setPinButton = ref;
      },
      type: "submit",
      disabled: isSubmitting,
      loading: isSubmitting,
      onClick: this.handleSetPinClick,
      basic: true,
      primary: true,
      fluid: true
    }, "Set PIN")), Boolean(hadaPin) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
      horizontal: true,
      className: "orDividerHorizontal"
    }, "OR"), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting,
      loading: isSubmitting,
      onClick: () => {
        this.handleSetPinClick({
          removePin: true
        });
      },
      basic: true,
      color: "grey",
      fluid: true
    }, "Remove PIN")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(ButtonLink, {
      color: "blue",
      onClick: () => {
        onManageAccount();
      }
    }, "Click here to Cancel and go back"))), (errors.pin || errors.resetToken || errors.update) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
      hidden: true
    }), /*#__PURE__*/React.createElement(Message, {
      size: "small",
      error: true,
      header: "Trouble setting PIN",
      list: _.concat(errors.pin, errors.resetToken, errors.update)
    }))), status === 'setPinSuccess' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
      attached: "top"
    }, /*#__PURE__*/React.createElement(Message.Header, null, "Success! Your PIN has been set.")), /*#__PURE__*/React.createElement(Message, {
      attached: "bottom"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "blue",
      fluid: true,
      basic: true,
      onClick: onManageAccount
    }, "Okay"))), status === 'removePinSuccess' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
      attached: "top"
    }, /*#__PURE__*/React.createElement(Message.Header, null, "Success! Your PIN has been removed.")), /*#__PURE__*/React.createElement(Message, {
      attached: "bottom"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "blue",
      fluid: true,
      basic: true,
      onClick: onManageAccount
    }, "Okay"))), ['noLink', 'invalidLink'].includes(status) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
      attached: "top"
    }, /*#__PURE__*/React.createElement(Message.Header, null, status === 'noLink' ? 'Invalid Link' : 'Expired or invalid link')), /*#__PURE__*/React.createElement(Message, {
      attached: "bottom"
    }, errors.pin || errors.resetToken || errors.update ? /*#__PURE__*/React.createElement(React.Fragment, null, "Oops. Something went wrong:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Message, {
      size: "tiny",
      error: true,
      header: "Trouble setting PIN",
      list: _.concat(errors.pin, errors.resetToken, errors.update)
    }), /*#__PURE__*/React.createElement(Divider, {
      hidden: true
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, "Oops. Something went wrong. Perhaps it took too long for the link to be activated from when it was issued, or this link has already been used.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Button, {
      color: "blue",
      fluid: true,
      basic: true,
      onClick: onManageAccount
    }, "Go Back"))));
  }
}